document.addEventListener('DOMContentLoaded', function () {
  const optionDataEl = document.querySelector('[data-marking-option-data]');
  if (!optionDataEl) return;

  const markingOptionData = JSON.parse(optionDataEl.textContent);
  const optionSets = markingOptionData.option_sets || [];
  const singleOptions = markingOptionData.single_options || [];

  const markingOptionContainer = document.querySelector('[data-product-marking-option]');
  const markingOptionTypeSelect = document.getElementById('marking-option-type-select');
  const markingOptionSetSelect = document.getElementById('marking-option-set-select');
  const markingOptionSet = document.querySelector('[data-marking-option-set]');
  const markingOptionSingle = document.querySelector('[data-marking-option-single]');
  const markingOptionSetInfo = document.querySelector('[data-marking-option-set-info]');
  const markingOptionSetPrice = document.querySelector('[data-marking-option-set-price]');
  const markingOptionSetContents = document.querySelector('[data-marking-option-set-contents]');
  const markingOptionSetNote = document.querySelector('[data-marking-option-set-note]');
  const markingOptionSetNoteText = document.querySelector('[data-marking-option-set-note-text]');

  if (markingOptionTypeSelect) {
    markingOptionTypeSelect.addEventListener('change', function () {
      const selectedValue = this.value;

      // すべてのオプションを非表示
      if (markingOptionSet) markingOptionSet.style.display = 'none';
      if (markingOptionSingle) markingOptionSingle.style.display = 'none';
      if (markingOptionSetInfo) markingOptionSetInfo.style.display = 'none';

      // マーキングオプション商品IDをリセット
      updateMarkingOptionProductIds();

      if (selectedValue === 'set' && markingOptionSet) {
        markingOptionSet.style.display = 'block';
      } else if (selectedValue === 'single' && markingOptionSingle) {
        markingOptionSingle.style.display = 'block';
      }
    });
  }

  // セット選択の処理
  if (markingOptionSetSelect) {
    markingOptionSetSelect.addEventListener('change', function () {
      const selectedSetName = this.value;

      if (selectedSetName) {
        const selectedSet = optionSets.find(set => set.name === selectedSetName);
        if (selectedSet) {
          // 価格を表示（セント単位なので100で割る）
          const price = parseFloat(selectedSet.price) / 100;
          markingOptionSetPrice.textContent = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(price);

          // セット内容を表示
          let contentsHtml = '';
          if (selectedSet.products && selectedSet.products.length > 0) {
            selectedSet.products.forEach(product => {
              contentsHtml += `
                <div class="marking-option-set-item">
                  <img src="${product.image_url}" alt="${product.title}" class="marking-option-set-item-image" width="40" height="40">
                  <div class="marking-option-set-item-text">${product.title}</div>
                </div>
              `;
            });
          }
          markingOptionSetContents.innerHTML = contentsHtml;

          // noteを表示
          if (selectedSet.note && selectedSet.note.trim()) {
            markingOptionSetNoteText.textContent = selectedSet.note;
            markingOptionSetNote.style.display = 'block';
          } else {
            markingOptionSetNote.style.display = 'none';
          }

          markingOptionSetInfo.style.display = 'block';

          // マーキングオプション商品IDを更新
          updateMarkingOptionProductIds();
        }
      } else {
        markingOptionSetInfo.style.display = 'none';
        updateMarkingOptionProductIds();
      }
    });
  }

  // 単体オプションのチェックボックスイベント
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('marking-option-single-item-checkbox')) {
      updateMarkingOptionProductIds();
    }
  });

  // マーキングオプション商品IDを更新する関数
  function updateMarkingOptionProductIds() {
    const markingOptionProductIdsInput = document.getElementById('marking-option-product-ids');
    const selectedProductIds = [];

    // オプションタイプを確認
    const optionType = markingOptionTypeSelect ? markingOptionTypeSelect.value : '';

    if (optionType === 'set') {
      // セットが選択されている場合
      const selectedSetName = markingOptionSetSelect ? markingOptionSetSelect.value : '';
      if (selectedSetName) {
        const selectedSet = optionSets.find(set => set.name === selectedSetName);
        if (selectedSet && selectedSet.products && selectedSet.products.length > 0) {
          selectedSet.products.forEach(product => {
            if (product.variants && product.variants.length > 0) {
              const firstVariant = product.variants[0];
              selectedProductIds.push(firstVariant.id);
            }
          });
        }
      }
    } else if (optionType === 'single') {
      // 単体オプションが選択されている場合
      const checkedBoxes = document.querySelectorAll('.marking-option-single-item-checkbox:checked');
      checkedBoxes.forEach(checkbox => {
        const optionName = checkbox.value;
        const selectedOption = singleOptions.find(option => option.name === optionName);
        if (selectedOption && selectedOption.products && selectedOption.products.length > 0) {
          selectedOption.products.forEach(product => {
            if (product.variants && product.variants.length > 0) {
              const firstVariant = product.variants[0];
              selectedProductIds.push(firstVariant.id);
            }
          });
        }
      });
    }

    // 値が空の場合は空文字列を設定
    markingOptionProductIdsInput.value = selectedProductIds.length > 0 ? selectedProductIds.join(',') : '';
  }

  // ---- マーキングプレビューによる絞り込み ----

  // 現在のプレビューが許可する商品ID。null は制限なし（プレビューを持たない商品）
  let allowedProductIds = null;

  const typeSelectOptions = markingOptionTypeSelect
    ? Array.prototype.slice.call(markingOptionTypeSelect.options)
    : [];
  const setSelectOptions = markingOptionSetSelect
    ? Array.prototype.slice.call(markingOptionSetSelect.options)
    : [];
  const singleItems = Array.prototype.slice.call(
    document.querySelectorAll('.marking-option-single-item')
  );

  // 含まれる商品がすべて許可されている場合のみ選択可能
  function isOptionAllowed(option) {
    if (allowedProductIds === null) return true;
    if (!option || !option.products) return false;
    return option.products.every(product => allowedProductIds.indexOf(product.id) !== -1);
  }

  function rebuildSelect(select, cachedOptions, isAllowedValue) {
    const currentValue = select.value;
    select.innerHTML = '';
    cachedOptions.forEach(optionEl => {
      if (optionEl.value === '' || isAllowedValue(optionEl.value)) {
        select.appendChild(optionEl);
      }
    });

    const stillSelectable = Array.prototype.some.call(
      select.options,
      optionEl => optionEl.value === currentValue
    );
    if (!stillSelectable) select.value = '';

    // カスタムドロップダウンの表示を作り直す
    const dropdown = select.closest('dropdown-input');
    if (dropdown && typeof dropdown.update === 'function') dropdown.update();

    return stillSelectable;
  }

  function applyPreviewFilter(productIds) {
    allowedProductIds = productIds || null;

    // 単体オプション
    singleItems.forEach(item => {
      const checkbox = item.querySelector('.marking-option-single-item-checkbox');
      const option = singleOptions.find(o => o.name === checkbox.value);
      const allowed = isOptionAllowed(option);
      item.style.display = allowed ? '' : 'none';
      if (!allowed) checkbox.checked = false;
    });

    // セットオプション
    if (markingOptionSetSelect) {
      const kept = rebuildSelect(markingOptionSetSelect, setSelectOptions, value =>
        isOptionAllowed(optionSets.find(set => set.name === value))
      );
      if (!kept && markingOptionSetInfo) markingOptionSetInfo.style.display = 'none';
    }

    // 選べるものが無くなった種別を選択肢から外す
    const hasSets = optionSets.some(isOptionAllowed);
    const hasSingles = singleOptions.some(isOptionAllowed);
    if (markingOptionTypeSelect) {
      rebuildSelect(markingOptionTypeSelect, typeSelectOptions, value =>
        value === 'set' ? hasSets : hasSingles
      );
    }

    // 選べるオプションが1件も無ければブロックごと非表示
    if (markingOptionContainer) {
      markingOptionContainer.style.display = hasSets || hasSingles ? '' : 'none';
    }

    // 現在の種別に合わせて表示状態を整える
    const optionType = markingOptionTypeSelect ? markingOptionTypeSelect.value : '';
    if (markingOptionSet) markingOptionSet.style.display = optionType === 'set' ? 'block' : 'none';
    if (markingOptionSingle) markingOptionSingle.style.display = optionType === 'single' ? 'block' : 'none';
    if (markingOptionSetInfo && optionType !== 'set') markingOptionSetInfo.style.display = 'none';

    updateMarkingOptionProductIds();
    document.dispatchEvent(new Event('marking:options-changed'));
  }

  document.addEventListener('marking:preview-change', function () {
    applyPreviewFilter(window.markingPreviewState.allowedOptionProductIds);
  });

  // プレビュー側が先に初期化されている場合は現在の状態を反映する
  if (window.markingPreviewState) {
    applyPreviewFilter(window.markingPreviewState.allowedOptionProductIds);
  }
});
